import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import { $textPrimary, $textTertiary } from '../../../../styles/colors/semantics'
import CtaV2 from '../../../CtaV2'
import Img from '../../../Img'

function TeamVrsHero({ image, title, subtitle, text, textB, textC, ctaV2 }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.image}>
          {/* task #67: render resolved descriptor via <Img> (fills the positioned wrapper) */}
          <Img image={image} priority objectFit="cover" />
        </div>
        <div className={styles.textWrapper}>
          <div className={styles.titleSection}>
            <SimpleBlockContent blocks={title.text} highlight={title.highlight} highlightSx={`color: ${$textTertiary.dark};`} highlightExactMatch/>
            <div className={styles.subtitle}>
              <SimpleBlockContent blocks={subtitle.text} highlight={subtitle.highlight} highlightSx={`color: ${$textPrimary.dark};`}/>
            </div>
          </div>
          <div className={styles.textSection}>
            <SimpleBlockContent blocks={text.text} highlight={text.highlight} highlightSx={`color: ${$textPrimary.dark};`}/>
          </div>
          <CtaV2 {...ctaV2} light/>
        </div>
      </div>
    </div>
  )
}

export default TeamVrsHero
